/* ========================================================================== *\
    Imports
/* ========================================================================== */
import json from '../../../hospital-ranking.json';
// import oldJson from '../../../hospital-ranking.json';

/* ========================================================================== *\
    Constants
/* ========================================================================== */
// import {forEach, find} from 'lodash';

let ranking = json;

// forEach(ranking, item => {
//     const name = item.Ziekenhuis;
//     const oldRanking = name === 'Stichting OLVG' ? oldJson['2017'] : oldJson['2018'];
//     const old = oldRanking.filter(o => o.Ziekenhuis === name);
//     const city = old.length ? old[0].Plaats : '';
//     const zipCode = old.length ? old[0].Postcode : '';
//     const coords = old.length ? old[0].coords : '';

//     if (city) {
//         item.Plaats = city;
//         item.Postcode = zipCode;
//         item.coords = coords;
//     } else {
//         console.error('Volgende ziekenhuis niet gevonden: ' + name);
//     }
// });

// console.log(ranking);


// import Geolocalizer from '../4-features/GeoLocalizer';
// let array = [],
//     year = '2018';

// forEach(newRank[year], arr => {
//     array.push(arr.Plaats);
// });

// var localizer = new Geolocalizer();
// localizer.Localize(array).then(resp => {
//     forEach(resp, (obj, i) => {
//         newRank[year][(newRank[year].length - 1) - i].coords = obj;
//     });

//     console.log(newRank[year])
// });

/* ========================================================================== *\
    Exports
/* ========================================================================== */
export const store = { ranking };